import classNames from 'classnames';
import React from 'react';
import styles from './TextAreaField.scss';

interface TextAreaFieldProps extends React.InputHTMLAttributes<HTMLTextAreaElement> {
    /**Unique id of the component */
    id: string;
    /**Label that appears on top of the input field */
    label: string;
    /**Appearance of the input field */
    appearance?: 'light' | 'dark'
    /**Show error state on input field */
    isError?: boolean;
    /**Error description that appears on the bottom of the input field */
    errorMessage?: string;
    /**Description that appears on the bottom of the input field */
    description?: string;
}

const TextAreaField = (props: TextAreaFieldProps) => {
    const {
        id,
        label,
        appearance = 'dark',
        isError,
        errorMessage,
        description,
        ...textAreaProps
    } = props;
    const { disabled } = textAreaProps;

    return (
        <div className={classNames(styles.textarea, styles[`textarea--appearance-${appearance}`])}>
            <label htmlFor={id} className={styles.textarea__label}>{label}</label>
            <textarea
                id={id}
                className={classNames(styles.textarea__input, { [styles['input--is-error']]: isError })}
                {...textAreaProps}
            />
            {description && !isError && <p className={styles.textarea__description}>{description}</p>}
            {isError && errorMessage && !disabled && <p className={styles.textarea__description}>{errorMessage}</p>}
        </div>
    )
};

export default TextAreaField;